import { Injectable } from "@angular/core";
import { SharePointConnection, ASharePointConnectionHttpService, ApiTestConnectionResult } from "@coso/connection-forms";
import { Observable, of } from "rxjs";
import { flatMap, catchError } from "rxjs/operators";
import { SharePointConnectionService } from "./sharepoint-connection.service";
import { ConnectionMapperService } from "./connection-mapper.service";
import { handleError } from "../utils/handle-error";

@Injectable({
  providedIn: "root"
})
export class SharePointConnectionHttpService extends ASharePointConnectionHttpService {
  constructor(private spService: SharePointConnectionService, private connectionMapper: ConnectionMapperService) {
    super();
  }
  testConnection(configuration: SharePointConnection): Observable<ApiTestConnectionResult> {
    const data = this.connectionMapper.mapFromSharePointConnection(configuration);
    const instanceId = sessionStorage.getItem("instance-id");
    return this.spService.testConnection(instanceId, data, Number(configuration.id)).pipe(
      flatMap((result) => {
        if (result.success) {
          return of({
            isSuccess: true,
            additionalData: result.data
          });
        } else {
          return of({
            isSuccess: false,
            error: result.error
          });
        }
      }),
      catchError((error) => {
        return of({
          isSuccess: false,
          error: handleError(error)
        });
      })
    );
  }
}
